import { Component, OnInit, Inject } from '@angular/core';
import { ApiManagerService } from '@ildes/services/api-manager.service'
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

const CLOSE = { id:'close', icon:'close' };
const ASCEND_METHODS = [
  {
    id:'TWO_SECTION_STAIRCASE',
    description:'Escalera de dos cuerpos'
  },
  {
    id:'CRANE',
    description:'Carro canasta (grúa)'
  },
  {
    id:'STEPLADDER',
    description:'Escalera de tijera'
  },
  {
    id:'HARNESS',
    description:'Pretales'
  },
]

@Component({
  selector: 'app-luminary-searcher-dialog',
  templateUrl: './luminary-searcher-dialog.component.html',
  styleUrls: ['./luminary-searcher-dialog.component.css']
})
export class LuminarySearcherDialogComponent implements OnInit {

  headerActions = [CLOSE];
  maintenance;
  taskData;

  searchLuminaryAdapter;
  ascendMethodOptions = ASCEND_METHODS;

  searchProjectAdapter;
  ignoreProject;
  constructor(
    public dialogRef: MatDialogRef<LuminarySearcherDialogComponent>,
    private apiManager: ApiManagerService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.maintenance = data.maintenance;
    this.ignoreProject = data.ignoreProject;
  }

  get projectId() {
    return this.selectedProject?.id;
  }

  ngOnInit(): void {
    const projectId = this.projectId;

    this.searchProjectAdapter = (data) => {
      return this.apiManager.listProjects(data);
    };

    this.searchLuminaryAdapter = (data) => {
      return this.apiManager.listLuminaries({
        number: data.text,
        ...projectId && { projectId }
      }, { error: true, timeout: true }).pipe(
        map(({ data }: any) => ( {data: this.normalize(data)}))
      )
    };
    this.taskData = new UntypedFormGroup({
      luminary: new UntypedFormControl(this.maintenance.luminary?.number ? { typed: this.maintenance.luminary.number, selected: { name: this.maintenance.luminary.number }} : ''),
      height: new UntypedFormControl(this.maintenance.height, Validators.min(1)),
      ascendMethod: new UntypedFormControl(this.maintenance.ascendMethod?.id),
      selectedProject: new UntypedFormControl(this.maintenance.project?.name ? { typed: this.maintenance.project?.name, selected: this.maintenance.project?.id ? this.maintenance.project: null }: null),
    });
  }

  normalize(data) {
    return data.map((object) => ({...object, ...{ name: object.number }}));
  }

  close(commit) {
    this.dialogRef.close({
      project: {name: this.projectTyped, id: this.projectId},
      luminary: this.luminary,
      ascendMethod: this.ascendMethodOption,
      height: this.height.value,
      commit
    });
  }

  headerAction() {
    this.dialogRef.close({ commit: false });
  }

  get projectTyped() {
    return this.taskData?.get('selectedProject')?.value?.typed;
  }

  public get selectedProject() {
    if (this.projectTyped) {
        return this.taskData?.get('selectedProject')?.value?.selected || { name: this.projectTyped};
    }

    return undefined;
}
  get luminary() {
    return this.taskData.controls.luminary.value.typed;
  }

  get height() {
    return this.taskData.controls.height;
  }

  get ascendMethod() {
    return this.taskData.controls.ascendMethod;
  }

  get ascendMethodOption() {
    return this.ascendMethodOptions.find((option) =>
      this.ascendMethod.value === option.id
    );
  }

}
